import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ImageStoreDTO } from 'business/models/Models';
import { getImageStoreInfo } from 'redux/thunks/GeneralSetup';

const initialState = {
  setupTabOption: 'general',
  imageStores: [],
};

const SetupTabSlice = createSlice({
  name: 'setuptab',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getImageStoreInfo.pending, (state, action) => {});
    builder.addCase(getImageStoreInfo.fulfilled, (state, action) => {
      state.imageStores = action.payload;
    });
  },
  reducers: {
    setSetupTab: (state, action: PayloadAction<string>) => {
      state.setupTabOption = action.payload;
    },
    setSetupImageStorage: (state, action: PayloadAction<ImageStoreDTO[]>) => {
      state.imageStores = action.payload;
    },
  },
});

export const { setSetupTab, setSetupImageStorage } = SetupTabSlice.actions;

export default SetupTabSlice.reducer;
